import { useEffect, useState, useContext } from "react";

import { LayoutContext } from "../layout/";

import { getEndpoint } from "../helper";

export default function ReturnPolicy({ }) {
    const { setPageTitle } = useContext(LayoutContext);

    useEffect(() => {
        setPageTitle('مرجوع کالا');
    }, []);

    return (
        <div className='p-4' style={{ color: '#3b3b3b' }}>
            <div className='ta-c mb-6'>
                <img className='d-if' src={getEndpoint("/pwa/img/logo.png")} style={{ width: '8rem' }} />
            </div>
            <b>مرجوع کالا</b>
            <div className='mt-2'>
                یکی از نگرانی های شما همیشه عودت اجناس مازاد می باشد. ما این امکان را برای شما فراهم کرده ایم تا پس از اتمام کار، اجناس مازاد خود را در صورتی که هیچ استفاده ای نشده باشد مرجوع کرده و مبلغ آن را طبق فاکتور خرید خود با شماره کارتی که برای ما ثبت کرده اید دریافت کنید.
            </div>
            <div>
                اجناس توسط خود شما و یا سرویس شرکت می تواند ارسال شود.
            </div>
            <div>
                برای انجام این کار می توانید با پشتیبانی تماس بگیرید.
            </div>
        </div>
    );
}